import PropTypes from 'prop-types'
import clsx from 'clsx'
import { NavLink } from 'react-router-dom'
import {
  ListItemText,
  ListItemIcon,
  ListItem,
  IconButton,
  List,
  Drawer,
  Box,
  Link,
  Tooltip,
  Typography,
  useMediaQuery,
} from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { useUserContext } from '../../../auth/UserProvider'

import * as routes from '../../../routes'
import useTranslations from '../../../i18n/useTranslations'
import Logo from '../../../assets/images/ctt-logo.svg'

import { ReactComponent as CaretDoubleLeft } from '../../../assets/icons/caret-double-left.svg'
import { ReactComponent as CaretDoubleRight } from '../../../assets/icons/caret-double-right.svg'

import useStyles from './styles'

const SidebarMenu = ({ menuItems, isOpen, onToggleMenu }) => {
  const classes = useStyles()
  const t = useTranslations()
  const user = useUserContext()

  const theme = useTheme()
  const isSmDown = useMediaQuery(theme.breakpoints.down('sm'))

  const filteredMenuItems = menuItems.filter(item => {
    if (item.requiredPermission && !user[item.requiredPermission]) {
      return false
    }
    if (
      item.allowedUserCodes &&
      !item.allowedUserCodes.includes(user.clientCode)
    ) {
      return false
    }

    return true
  })

  return (
    <Drawer
      variant="permanent"
      className={clsx(classes.drawer, {
        [classes.drawerOpen]: isOpen,
      })}
      classes={{
        paper: clsx(classes.paper, {
          [classes.drawerOpen]: isOpen,
        }),
      }}
    >
      {isSmDown ? null : (
        <Box className={classes.logoContainer}>
          <Link underline="none" component={NavLink} to={routes.HOME.linkTo()}>
            <img src={Logo} alt="" className={classes.logo} />
          </Link>
          <IconButton
            onClick={onToggleMenu}
            className={classes.toggleButton}
            size="large"
          >
            {isOpen ? <CaretDoubleLeft /> : <CaretDoubleRight />}
          </IconButton>
        </Box>
      )}
      <List component="nav" className={classes.nav}>
        {filteredMenuItems.map(({ title, Icon, path, extraClass }) => (
          <Tooltip
            key={title}
            placement="right"
            title={<Typography variant="body2">{t(title)}</Typography>}
            disableHoverListener={isOpen}
            disableFocusListener={isOpen}
            disableTouchListener={isOpen}
          >
            <ListItem
              button
              component={NavLink}
              exact
              to={path}
              className={clsx(classes.navItem, classes[extraClass])}
              activeClassName="Mui-selected"
              // selected={index === 0} // Mock
            >
              <ListItemIcon className={classes.navIcon}>
                <Icon size={24} />
              </ListItemIcon>
              <ListItemText className={classes.navText} primary={t(title)} />
            </ListItem>
          </Tooltip>
        ))}
      </List>
    </Drawer>
  )
}

SidebarMenu.propTypes = {
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      Icon: PropTypes.elementType,
      path: PropTypes.string,
    }),
  ),
  isOpen: PropTypes.bool,
  onToggleMenu: PropTypes.func,
}

export default SidebarMenu
